<!-- 跳转到支付宝扫码页面的form表单 -->
<template>
     <div v-html = "payGateWay">{{payGateWay}}</div>
</template>

<script>
    export default {
        name: 'AliPay',
        data(){
            return {
                payGateWay:''
            }
        } ,

        created(){

        },

        mounted () {
            let form = this.$route.query.htmlData;
            this.payGateWay = form;
            this.$nextTick(()=> {
                document.forms[0].submit();
            })
        }
    }
</script>